import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: ActiveSubstanceFamilyUpdateInput!
  ) {
    updateOneActiveSubstanceFamily(
      where: {
        id: $id
      }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Familía actualizada`, mutationTypes.UPDATE)
)

